module.exports = __webpack_public_path__ + "static/img/sharp_detail.89c2df36.png";